import { createBrowserRouter } from 'react-router-dom';
import { AuthenticatedLayout } from './layouts/AuthenticatedLayout';
import { LoginPage } from './pages/LoginPage';
import { CallbackPage } from './pages/CallbackPage';
import { SubdomainListPage } from './pages/SubdomainListPage';
import { ApiKeyManagementPage } from './pages/ApiKeyManagementPage';

/**
 * Application route configuration using createBrowserRouter (data router pattern).
 * Public routes (/login, /callback) are top-level.
 * Protected routes are children of AuthenticatedLayout.
 */
export const router = createBrowserRouter([
  {
    path: '/login',
    element: <LoginPage />,
  },
  {
    path: '/callback',
    element: <CallbackPage />,
  },
  {
    element: <AuthenticatedLayout />,
    children: [
      {
        index: true,
        element: <SubdomainListPage />,
      },
      {
        path: 'subdomains/:subdomainId/keys',
        element: <ApiKeyManagementPage />,
      },
    ],
  },
], {
  basename: '/user-console',
});
